<script>
  import { formatDate } from '/helper'
  import { _ } from 'svelte-i18n'
  
  import Card from '/components/Atoms/Card'
  import PageHeader from '/components/Atoms/PageHeader'

  export let data

</script>

<PageHeader>
  {$_("category.news")}
</PageHeader>

<section>

  {#each data.News as news}
    <div class="entry">
      <Card link={{ section: "news", slug: news.slug }}>
        {#if news.postDate}
          <div class="date">
            {formatDate(new Date(news.postDate), 'event-day-month-year')}
          </div>
        {/if}
          { news.title }
      </Card>
    </div>
  {/each}
  
</section>

<style lang="scss">
  section {
    @include grid-padding;
  }

  .entry {
    margin-bottom: 20px;
    @include typo-serif-text-28;
  }

  .date {
    @include typo-serif-small-caps-28;
  }

</style>